import { defineMessages } from 'react-intl-next';

export const i18n: {
	salesforceStageFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	salesforceStageFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	salesforceStageFilterLabel: {
		id: 'search-page.salesforce.filter.stage',
		defaultMessage: 'Stage',
		description: 'Label for filtering by Salesforce opportunity stage',
	},
	salesforceStageFilterNoOptions: {
		id: 'search-page.salesforce.filter.stage.no-options',
		defaultMessage: 'No stages available',
		description:
			'Message shown in the Salesforce stage filter dropdown when no stage options are available',
	},
});
